/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Node_LabelInputs */

const cs_workflow_node_label = /** @type {(inputs: Workflow_Node_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označení`)
};

const en_workflow_node_label = /** @type {(inputs: Workflow_Node_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Workflow_Node_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_node_label = /** @type {((inputs?: Workflow_Node_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Node_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_node_label(inputs)
	return cs_workflow_node_label(inputs)
});